export function FailPage() {
    return (
        <div className="account-creation-failure centered-grid">
            <h1>Oops something went wrong!</h1>
            <p>Please retry and if it persists contact us for support</p>
        </div>
    );
}